// import { menuConfig } from '@/config';
import axClient from '../../services';
import * as types from '../types';

const state = {
  province: [],
  user: null,
  liveOnlineNum: 0,
  socketMsg: {},
  userMenu: [],
};

const getters = {
  province: (s) => s.province,
  user: (s) => s.user,
  userMenu: (s) => s.userMenu,
  liveOnlineNum: (s) => s.liveOnlineNum,
  socketMsg: (s) => s.socketMsg,
  getServicersBymodel: (s) => (modelId) => s.servicers.filter((servicer) => servicer.modelIds.includes(modelId)),
};

const mutations = {
  [types.GET_PROVICE_ENTS](s, data) {
    s.province = data;
  },
  [types.GET_USER](s, data) {
    s.user = data;
  },
  [types.GET_LIVING_NUM](s, data) {
    s.liveOnlineNum = data;
  },
  [types.SET_SOCKET_MSG](s, data) {
    s.socketMsg = data;
  },
  [types.SET_USER_MENU](s, data) {
    s.userMenu = data;
  },
};

const actions = {
  async getProvince({ commit }) {
    const res = await axClient.common.getProvice();
    if (res && res.length) {
      commit(types.GET_PROVICE_ENTS, res);
    }
  },
  user({ commit }, data) {
    commit(types.GET_USER, data);
  },
  liveOnlineNum({ commit }, data) {
    commit(types.GET_LIVING_NUM, data);
  },
  socketMsg({ commit }, data) {
    commit(types.SET_SOCKET_MSG, data);
  },
  userMenu({ commit }, data) {
    commit(types.SET_USER_MENU, data);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};